import React, { useState } from 'react';
import { getTableCollector } from '../../helpers/collectors'
import { observer } from "mobx-react-lite"

import Search from './Search'
import { TableConfig } from '../../types';
import AppState from '../../AppState';
import { File } from './types';
import FileComponent from './FileComponent';

const getFilteredFiles = (files: File[], tableConfig: TableConfig, search: String) => {
    if (!files) {
        return []
    }

    return files.map(file => {
        if (!getTableCollector(tableConfig, search)(file)) {
            return null
        }

        return file
    }).filter(x=>x)
}

interface Props {
    state: AppState,
    tableConfig: TableConfig
}

const FileList = observer(({state, tableConfig}: Props) => {
    const [search, setSearch] = useState('')

    const filteredFiles = getFilteredFiles(state.files, tableConfig, search)

    if ((!state.files || !search) && 
        (!filteredFiles || !search) && 
        !filteredFiles.length) {
        return null
    }

    return (
        <div>
            <h6>{tableConfig.title}</h6>

            { tableConfig.searchEnabled ? <Search search={search} setSearch={setSearch} /> : null }

            <table className="file-list">
                <tbody>
                { filteredFiles.map(file => {
                    const gigHasFile = !!state.gigToEdit?.files?.find(gigFile => file && (gigFile.id === file.id))
                    const pushFile = !gigHasFile ? (file: File) => state.pushCurrentGigFile(file) : null
                    const removeFile = gigHasFile ? (file: File) => state.removeCurrentGigFile(file) : null
                    if (!file) {
                        return null
                    }
                    return <FileComponent
                        key={file.path} 
                        file={file} 
                        config={state.config}
                        setEditFile={() => state.setFileToEdit(file)}
                        handleUpdate={state.handleFileUpdate}
                        tableConfig={tableConfig}
                        pushFile={pushFile}
                        removeFile={removeFile}
                    />
                })}
                { !filteredFiles.length ? <p>Ei oo semmosta</p> : null }
                </tbody>
            </table>
        </div>
    );
})

export default FileList;
